export const notificationCenter = {
  markAsRead: "Marcar como leído",
  activity: "Actividad",
  read: "Leído",
  unread: "No leído",
};
